(function () {
  'use strict';

  // Fixed (preconfigured) bundle CTA: ONE /cart/add.js call adding every variant
  // stamped with the offer identity - the same rails as the builder:
  //   properties[_bundle] = <offer handle>  (exact-match trigger activates the offer)
  //   properties[_bundle_tier] = <pct>      (informational)
  // The applicator then arms the offer's code; the drawer groups the lines.
  // Response-verified (fetch resolves on 4xx); no retry loop - one attempt per tap.
  function boot() {
    var root = document.querySelector('[data-fixed-bundle]');
    if (!root) return;
    // A block-composed page can have SEVERAL add-to-cart buttons (hero text
    // block + product list + closing CTA) - bind them all; they share one add.
    var ctas = root.querySelectorAll('[data-fb-cta]');
    var jsonEl = root.querySelector('[data-fb-variants]');
    if (!ctas.length || !jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var handle = root.getAttribute('data-offer-handle');
    var pct = root.getAttribute('data-pct') || '0';

    ctas.forEach(function (cta) { wireCta(cta); });

    function wireCta(cta) {
    // each button uses ITS OWN adjacent status line when one exists
    var status = cta.parentElement.querySelector('[data-fb-status]') || root.querySelector('[data-fb-status]');
    cta.addEventListener('click', function () {
      ctas.forEach(function (c) { c.disabled = true; });
      if (status) status.textContent = 'Adding your set...';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: variants.map(function (id) {
            return { id: id, quantity: 1, properties: { _bundle: handle, _bundle_tier: String(pct) } };
          })
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add the set'); });
          return r.json();
        })
        .then(function () {
          if (status) status.textContent = '';
          ctas.forEach(function (c) { c.disabled = false; });
          document.dispatchEvent(new Event('cart:refresh'));
          if (window.cartDrawer && typeof window.cartDrawer.open === 'function') window.cartDrawer.open();
        })
        .catch(function (err) {
          ctas.forEach(function (c) { c.disabled = false; });
          if (status) status.textContent = err && err.message ? err.message : 'Could not add the set - please try again.';
        });
    });
    }
  }

  // Quick view (from the builder's affordance): tap a piece -> modal with the
  // full product description, fetched on demand from the public /products/<handle>.js
  // (the registry deliberately doesn't carry descriptions). textContent only.
  function bootQuickView() {
    var root = document.querySelector('[data-fixed-bundle]');
    var modal = document.querySelector('[data-fb-qv-modal]');
    if (!root || !modal) return;
    var img = modal.querySelector('[data-fb-qv-img]');
    var title = modal.querySelector('[data-fb-qv-title]');
    var desc = modal.querySelector('[data-fb-qv-desc]');
    var cache = {};
    var seq = 0; // stale-response guard: only the LATEST open() may render

    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }
    function open(handle) {
      var my = ++seq;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      title.textContent = 'Loading...';
      desc.textContent = '';
      var load = cache[handle] ||
        (cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); }));
      load.then(function (prod) {
        if (my !== seq) return; // a newer open() superseded this response (race)
        title.textContent = prod.title;
        // description is merchant HTML -> strip to text (no HTML injection)
        var tmp = document.createElement('div');
        tmp.innerHTML = prod.description || '';
        desc.textContent = tmp.textContent.trim();
        if (img && prod.featured_image) {
          // sized CDN variant, not the multi-MB original
          var join = prod.featured_image.indexOf('?') === -1 ? '?' : '&';
          img.src = prod.featured_image + join + 'width=600';
          img.alt = prod.title;
        }
      }).catch(function () {
        delete cache[handle];
        if (my !== seq) return;
        title.textContent = 'Could not load details';
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fb-qv]');
      if (t) { open(t.getAttribute('data-fb-qv')); return; }
      if (e.target.closest('[data-fb-qv-close]')) close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-fb-qv]')) open(e.target.getAttribute('data-fb-qv'));
    });
  }

  // Sticky buy bar: slides up once the top of the page scrolls out of view
  // (both design mocks carried this - the CTA follows the reader).
  function bootSticky() {
    var root = document.querySelector('[data-fixed-bundle]');
    var bar = document.querySelector('[data-fb-sticky]');
    if (!root || !bar || typeof IntersectionObserver !== 'function') return;
    var sentinel = root.querySelector('.fb-block, .fixed-bundle__hero');
    if (!sentinel) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-shown', !e.isIntersecting); });
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
  }

  function bootAll() { boot(); bootQuickView(); bootSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
})();
